export interface IUser {
  id?: any;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  userSelected?: string;
  szIsZastupanje?: boolean;
  szIpsRegistar?: string;
  szIps?: string;
  szSubjectOfRepresentationSelected?: boolean;
  mandate?: string[];
  createdBy?: string;
  createdDate?: Date | null;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | null;
  password?: string;
}

export const defaultValue: Readonly<IUser> = {
  id: '',
  login: '',
  firstName: '',
  lastName: '',
  email: '',
  activated: true,
  langKey: '',
  authorities: [],
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
  password: '',
};

export interface JWTUser {
  idUser?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  authorities?: any[];
  userSelected?: string;
  szIsZastupanje?: boolean;
  szIpsRegistar?: string;
  szIps?: string;
  szSubjectOfRepresentationSelected?: boolean;
  mandate?: string[];
  keycloakImpersonatorUsername?: string;
}
